export default __webpack_public_path__ + "static/media/campaign.ccfe88d7.png";